"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9417 17.0902C10.9417 17.5664 10.551 18 10.0038 18C9.47871 18 9.05835 17.5955 9.05835 17.0902L9.05835 5.0964L4.61884 9.36841C4.24604 9.72714 3.6524 9.72714 3.2796 9.36841C2.9068 9.00967 2.9068 8.43843 3.2796 8.0797L9.34579 2.24239L9.36233 2.22875C9.48234 2.12977 9.62219 2.06135 9.76788 2.0263L9.83562 2.01L9.85431 2.01C9.86889 2.0078 9.88646 2.00566 9.90642 2.00427C10.0465 1.99171 10.1947 2.00625 10.3369 2.05586C10.4622 2.0976 10.5725 2.16378 10.6696 2.25721L16.7126 8.07215C16.9164 8.25641 17 8.50899 17 8.72041C17 8.95417 16.9012 9.18715 16.7204 9.36113C16.3476 9.71986 15.754 9.71986 15.3812 9.36113L10.9417 5.08912L10.9417 17.0902Z",
    fill: "#727B7F"
  }));
};